import { RhNumberField } from '../../../../../../dum';
import React from 'react';
import { SUBTOTAL } from '../expense-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function SubtotalInput() {
    // Subtotal is fully derived from the product line items (see
    // use-calculate-expense-resources-total), so it is read-only here.
    return (
        <RhNumberField
            name={SUBTOTAL}
            label={shortLabel(FIELD_LABELS.subtotal)}
            disabled
        />
    );
}
